var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"system-pages-2767d75e3f6b99d71d484de0c38b1d9b1e119042"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/system-pages";

import env from '@y2/environments';

import { initSentry, OWNERS } from '../../sentry.config.base';

initSentry(env.name, 'system-pages', OWNERS.DEADPOOL);
